import React from "react";
import { CgMenuRight } from "react-icons/cg";
import { FaRegUser } from "react-icons/fa";
import { FaArrowLeft } from "react-icons/fa6";
import {
  MdLogout,
  MdOutlinePerson,
  MdOutlineShoppingBag,
  MdOutlineStore,
} from "react-icons/md";
import { PiPasswordFill } from "react-icons/pi";
import { TbFileLike } from "react-icons/tb";
import { connect } from "react-redux";
import {
  Link,
  Redirect,
  RouteComponentProps,
  withRouter,
} from "react-router-dom";
import BasketSidebar from "../../components/basket-sidebar/basket-sidebar";
import SearchInputComponent from "../../components/search-page/search-input.component";
import SidebarCategories from "../../components/sidebar-categories/sidebar-categories";
import { ClientModel } from "../../entities/client.model";
import store from "../../store";
import "./layout.scss";

interface TopLayoutProps extends RouteComponentProps {
  sidebarOpen: boolean;
  basketOpen: boolean;
  basketCount: number;
  basketValue: number;
  client: ClientModel;
  settings: any;
  location: any;
}

interface TopLayoutState {
  redirect: string;
  clientMenuOpen: boolean;
  mobileSearchOpen: boolean;
}

const mapStateToProps = (state: any) => {
  let basketCount = 0;

  if (state.basket) {
    for (let productId of state.basket.addedIds) {
      basketCount += state.basket.quantityById[productId];
    }
  }

  return {
    sidebarOpen: state.sidebarOpen,
    basketOpen: state.basketOpen,
    basketCount: basketCount,
    basketValue: state.basket.totalAmount,
    client: state.client,
    settings: state.settings,
  };
};

class MainLayout extends React.Component<TopLayoutProps, TopLayoutState> {
  public closingMenu = false;

  constructor(props: any) {
    super(props);
    this.state = {
      redirect: "",
      clientMenuOpen: false,
      mobileSearchOpen: false,
    };
    this.handleClickOnLogin = this.handleClickOnLogin.bind(this);
    // document.addEventListener("click", this.handleClick);
  }

  toggleMenu() {
    this.setState({ clientMenuOpen: !this.state.clientMenuOpen });
  }

  showClientMenu() {
    this.closingMenu = false;
    this.setState({ clientMenuOpen: true });
  }

  getOutOfClientMenu() {
    this.closingMenu = true;
    setTimeout(() => {
      if (this.closingMenu) {
        this.setState({ clientMenuOpen: false });
      }
    }, 200);
  }

  openSidebar = () => {
    store.dispatch({
      type: "sidebarOpen",
      value: true,
    });

    document.body.classList.add("no-scroll");
  };

  openBasketSidebar = () => {
    if (this.props.basketValue === 0) {
      return;
    }
    store.dispatch({
      type: "basketOpen",
      value: true,
    });

    document.body.classList.add("no-scroll");
  };

  closeBasketSidebar = () => {
    if (this.props.basketValue === 0) {
      return;
    }
    store.dispatch({
      type: "basketOpen",
      value: false,
    });

    document.body.classList.add("no-scroll");
  };

  search = () => {
    window.open("/search");
  };

  logout() {
    localStorage.removeItem("clientToken");
    store.dispatch({ type: "logout" });
  }

  handleClickOnLogin() {
    if (this.props.basketOpen) {
      this.closeBasketSidebar();
    }
  }

  openMobileSearch = () => {
    this.setState({ mobileSearchOpen: true });
  };

  closeMobileSearch = () => {
    this.setState({ mobileSearchOpen: false });
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }
    return (
      <div className="main-layout" id="main-layout">
        <div className="upper-container">
          <div className="upper-section">
            <div className="mid section">
              <Link to="/" className="logo-text">
                <img
                  src="/logo.png"
                  alt="logo"
                  className="logo-img"
                  width="50"
                />
              </Link>
              <div className="link">
                <Link
                  to="/"
                  className={`home ${
                    this.props.location.pathname === "/" ? "active" : ""
                  }`}
                >
                  Нүүр хуудас
                </Link>
                <Link
                  to="/search"
                  className={`product ${
                    this.props.location.pathname === "/search" ? "active" : ""
                  }`}
                >
                  Бүтээгдэхүүн
                </Link>
              </div>
            </div>
            <div className="right section">
              <div className="search section">
                {this.props.location.pathname !== "/catalog" && this.props.location.pathname !== "/store" && (
                <SearchInputComponent
                  onMobileSearchClick={this.openMobileSearch}
                />)}
              </div>

              {this.props.client.superUser ? 
              <div className="store-icon">
                <Link to="/store" className="cart">
                  <MdOutlineStore className="icon-store" />
                </Link>
              </div>
              : null}

              <div
                className={
                  "basket" +
                  (this.props?.basketValue > 0 ? " highlighted" : "")
                }
                onClick={() => this.openBasketSidebar()}
              >
                <span className="cart">
                  <MdOutlineShoppingBag className="icon-basket" />
                  <div className="basket-count">{`${this.props?.basketCount}`}</div>
                </span>
              </div>

              <div className="controls">
                {this.props.client?.id ? (
                  <React.Fragment>
                    <div
                      className="client-menu"
                      onClick={() => this.toggleMenu()}
                      onMouseEnter={() => this.showClientMenu()}
                      onMouseLeave={() => this.getOutOfClientMenu()}
                    >
                      <FaRegUser className="icon-user" />
                      {this.state.clientMenuOpen ? (
                        <div className="client-dropdown">
                          <div className="dropdown-item">
                            <Link
                              to="/client/orders"
                              onClick={() =>
                                this.setState({ clientMenuOpen: false })
                              }
                            >
                              <span className="menu-icon">
                                <MdOutlineShoppingBag size={28} />
                              </span>
                              <span className="menu-text">
                                Миний захиалгууд
                              </span>
                            </Link>
                          </div>
                          <div className="dropdown-item">
                            <Link
                              to="/client/account"
                              onClick={() =>
                                this.setState({ clientMenuOpen: false })
                              }
                            >
                              <span className="menu-icon">
                                <MdOutlinePerson size={28} />
                              </span>
                              <span className="menu-text">
                                Миний мэдээлэл
                              </span>
                            </Link>
                          </div>
                          <div className="dropdown-item">
                            <Link
                              to="/client/change-password"
                              onClick={() =>
                                this.setState({ clientMenuOpen: false })
                              }
                            >
                              <span className="menu-icon">
                                <PiPasswordFill size={28} />
                              </span>
                              <span className="menu-text">
                                Нууц үг солих
                              </span>
                            </Link>
                          </div>
                          <div className="dropdown-item">
                            <Link
                              to="/client/saved-products"
                              onClick={() =>
                                this.setState({ clientMenuOpen: false })
                              }
                            >
                              <TbFileLike size={28} />
                              <span className="menu-text">
                                Хадгалсан бараа
                              </span>
                            </Link>
                          </div>

                          <div
                            className="dropdown-item2"
                            onClick={() => this.logout()}
                          >
                            <MdLogout size={28} />
                            <span className="menu-text">
                              Вебсайтаас гарах
                            </span>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </React.Fragment>
                ) : (
                  <Link to="/login" onClick={this.handleClickOnLogin}>
                    <FaRegUser className="icon-user" />
                  </Link>
                )}
              </div>
              <div className="left section">
                <div
                  className="burger-menu"
                  onClick={() => this.openSidebar()}
                >
                  <CgMenuRight className="icon-burger" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`mobile-search-overlay ${
            this.state.mobileSearchOpen ? "active" : ""
          }`}
        >
          <div className="close-btn" onClick={this.closeMobileSearch}>
            <FaArrowLeft size={25} color="white" />
          </div>
          {this.props.location.pathname !== "/catalog" && (
          <SearchInputComponent />)}
        </div>
        <div
          className={`left-sidebar-container ${
            this.props.sidebarOpen ? "active" : ""
          }`}
        >
          {this.props.sidebarOpen ? <SidebarCategories /> : null}
        </div>
        <div className="right-sidebar-container">
          {this.props.basketOpen ? <BasketSidebar></BasketSidebar> : null}
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(withRouter(MainLayout));
